import { Market } from "../../contracts";

export const findFirstAvailableMarket = (markets: Market[], ids: string[]): Market => {
    let market, len = ids.length;

    for (let i = 0; i < len; i += 1) {
        market = markets.find(m => {
            return m.marketType.id === ids[i];
        });
        if (market) { break; }
    }

    return market;
}